"use strict";

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var TextField_1 = __importDefault(require("@material-ui/core/TextField"));

var Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));

var utils_1 = __importDefault(require("@nexys/utils"));

var MyAutocomplete = function MyAutocomplete(props) {
  var name = props.name,
      data = props.data,
      _onChange = props.onChange,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      id = props.id,
      label = props.label,
      promise = props.promise;

  var _react_1$useState = react_1.useState(props.options || []),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      options = _react_1$useState2[0],
      setOptions = _react_1$useState2[1];

  var value = data ? utils_1.default.ds.get(name.toString(), data) : undefined;
  react_1.useEffect(function () {
    setOptions(props.options || []);
  }, [props.options]);

  if (promise) {
    promise.then(function (x) {
      setOptions(x);
    });
  }

  return react_1.default.createElement(Autocomplete_1.default, {
    id: id ? id : name.toString(),
    options: options,
    getOptionLabel: function getOptionLabel(option) {
      return option.name;
    },
    value: value,
    renderInput: function renderInput(params) {
      return react_1.default.createElement(TextField_1.default, Object.assign({
        label: label
      }, params, {
        fullWidth: true
      }));
    },
    disabled: disabled,
    renderOption: function renderOption(option) {
      return option.name;
    },
    onChange: function onChange(_, newValue) {
      _onChange({
        name: name.toString(),
        value: newValue
      });
    }
  });
};

exports.default = MyAutocomplete;